import 'css-chunk:src/components/ResultsDisplay.module.scss';export default {
  "results": "_results_1pq8k_1",
  "section": "_section_1pq8k_10",
  "dropper": "_dropper_1pq8k_14",
  "name": "_name_1pq8k_17",
  "header": "_header_1pq8k_20",
  "contents": "_contents_1pq8k_27",
  "extra": "_extra_1pq8k_31",
  "recipe": "_recipe_1pq8k_37",
  "quest": "_quest_1pq8k_38"
};